export const PERMITTED_FULL_SCREEN_TPAS_IN_MOBILE = {
	WIX_CHAT: '14517e1a-3ff0-af98-408e-2bd6953c36a2',
	WIX_RESTAURANTS: '13e8d036-5516-6104-b456-c8466db39542',
}
